import React, { useRef, useState, useEffect, useMemo } from 'react';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import { 
  ClassicEditor, 
  Essentials, 
  Paragraph, 
  BlockQuote,
  HorizontalLine,
  Bold, 
  Italic, 
  List,
  Alignment,
  Indent,
	IndentBlock,
	PasteFromOffice,
	SourceEditing,
	Strikethrough,
	Subscript,
	Superscript,
	Underline
} from 'ckeditor5';

import './ckeditor5.css';

export default function CkEditor({ value, onChange, location="statement" }) {

  const editorContainerRef = useRef(null);
	const editorRef = useRef(null);

	const [isLayoutReady, setIsLayoutReady] = useState(false);
  const [ currentContent, setCurrentContent ] = useState(value || ' ');
  
  const handleEditorChange = (data) => onChange(data)

  useEffect(() => {
    setCurrentContent(value || ' ');
  },[value])

  useEffect(() => {
		setIsLayoutReady(true);
		return () => setIsLayoutReady(false);
	}, []);

  const { editorConfig } = useMemo(() => {
		if (!isLayoutReady) {
			return {};
		}

		return {
      editorConfig: {
				toolbar: {
					items: [
						'bold',
						'italic',
						'underline',
						'strikethrough',
						'subscript',
						'superscript',
						'|',
						'horizontalLine',
						'blockQuote',
						'|',
						'alignment',
						'|',
						'bulletedList',
						'numberedList',
						'outdent',
						'indent',
            '|',
            'sourceEditing',
					],
					shouldNotGroupWhenFull: false
				},
				plugins: [
					Alignment,
					BlockQuote,
					Bold,
					Essentials,
					HorizontalLine,
					Indent,
					IndentBlock,
					Italic,
					List,
					Paragraph,
					PasteFromOffice,
					Strikethrough,
          SourceEditing,
					Subscript,
					Superscript,
					Underline
				],
				initialData: currentContent || ' ',
				licenseKey: 'GPL',
				placeholder: 'Type or paste your content here!'
			}
		};
	}, [isLayoutReady, currentContent]);

  return (
    <div className="main-container">
			<div className="editor-container editor-container_classic-editor" ref={editorContainerRef}>
				<div className="editor-container__editor text-neutral-900">
					<div ref={editorRef}>
            { editorConfig && (
              <CKEditor 
                onChange={ (event, editor) => handleEditorChange(editor.getData()) }
                editor={ClassicEditor} 
                config={editorConfig} 
                data={currentContent}
              />
            )}
          </div>
				</div>
			</div>
		</div>


    // <div className="text-neutral-800">
    //   <CKEditor
    //     editor={ ClassicEditor }
    //     config={ {
    //       initialData: "Testing...",
    //       licenseKey: 'GPL',
    //       plugins: [ Essentials, Paragraph, Bold, Italic, List, Indent, Strikethrough, Underline, Superscript, Subscript, SourceEditing ],
    //       toolbar: [ 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'superscript', 'subscript', '|', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'sourceEditing' ],
    //       initialData: '<p>Hello from CKEditor 5 in React!</p>',
    //     } }
    //   />
    // </div>
  );
}
